let config = {}


 
// 根据环境变量动态设置API URL
if (process.env.NODE_ENV === 'development') {
  // 开发环境使用本地服务器
  // config.apiUrl = "http://172.0.1.175:8081"
  config.apiUrl = "http://127.0.0.1:8081"
  // config.apiUrl = "https://server.xiangjing.top"
} else {
  // 生产环境使用正式服务器
  config.apiUrl = "https://server.xiangjing.top"
}

export default config